export default __webpack_public_path__ + "static/media/next-step-arrow-down.575a2279.svg";